import notificationMethods from './notificationMethods'

const notificationTypes = {
	'USER-TAGGED-IN-POST': {
		type: 'USER-TAGGED-IN-POST',
		methods: notificationMethods.all
	},
	'USER-FOLLOWED-YOU': {
		type: 'USER-FOLLOWED-YOU',
		methods: notificationMethods.all
	},
	'USER-VERIFIED-YOU': {
		type: 'USER-VERIFIED-YOU',
		methods: notificationMethods.all
	},
	'FOLLOWING-POSTED': {
		type: 'FOLLOWING-POSTED',
		methods: notificationMethods.all
	},
	'USER-LIKED-YOUR-POST': {
		type: 'USER-LIKED-YOUR-POST',
		methods: notificationMethods.all
	},
	'YOU-WERE-ACTIVATED': {
		type: 'YOU-WERE-ACTIVATED',
		methods: notificationMethods.all
	},
	'USER-POST-RECEIVED-COMMENT': {
		type: 'USER-POST-RECEIVED-COMMENT',
		methods: notificationMethods.all
	},
	'USER-PROFILE-INCOMPLETE': {
		type: 'USER-PROFILE-INCOMPLETE',
		methods: notificationMethods.all
	},
	'ITEM-TAGGED-IN-KIT': {
		type: 'ITEM-TAGGED-IN-KIT',
		methods: notificationMethods.all
	}
}

export default notificationTypes



// WEBPACK FOOTER //
// ./src/enums/notificationTypes.js